import { getBreakpoint, isDesktop } from "./utils";

/**
* Gets the CTA style for a given element
* @param {object} $el - the jQuery target element
* @returns {string} the CTA style for the element
*/
const getCTAStyle = ($el) => {
    let ctaStyleSmall = $el.data("cta-style-small") ? $el.data("cta-style-small") : null;
    let ctaStyleLarge = $el.data("cta-style-large") ? $el.data("cta-style-large") : null;
    let ctaStyle = isDesktop() ? ctaStyleLarge : ctaStyleSmall;

    if (ctaStyle) {
        $el.removeClass(`${ctaStyleSmall} ${ctaStyleLarge}`);
        $el.addClass(ctaStyle);
    }
};

/**
* Sets the style for the call-to-action button in the hero banner
* @returns {void}
*/
const setCTAStyle = () => {
    let $heroBannerCTA = $(".hero-banner .hero-banner-link");

    if ($heroBannerCTA.length > 0) {
        $heroBannerCTA.each(function () {
            getCTAStyle($(this));
        });
    }
};

/**
 *  Get color for breakpoint
 *  @param {Object} el - selector for element
 */
const getColor = (el) => {
    let colorSmall = el.data("color-small") ? el.data("color-small") : null;
    let colorLarge = el.data("color-large") ? el.data("color-large") : null;
    let textColor = isDesktop() ? colorLarge : colorSmall;

    if (textColor) {
        el.find(".js-banner-color").css("color", textColor);
    }
};

/**
 *  Get height for image
 *  @param {Object} el - selector for element
 */
const getHeight = (el) => {
    let heightSmall = el.data("height-small") ? el.data("height-small") : null;
    let heightMedium = el.data("height-medium") ? el.data("height-medium") : null;
    let heightLarge = el.data("height-large") ? el.data("height-large") : null;
    let height;
    let br = getBreakpoint();

    switch (br) {
        case "md":
            height = heightMedium;
            break;
        case "lg":
            height = heightLarge;
            break;
        default:
            height = heightSmall;
    }

    if (height) {
        el.css("height", height);
    }
};

/**
 *  Set color for banner
 */
const setTextColor = () => {
    let $textContainer = $(".hero-banner .hero-banner-text-wrapper");
    let $tabPanel = $textContainer.closest(".tab-pane");

    if ($textContainer.length > 0) {
        $textContainer.each(function () {
            getColor($(this));
        });
    }

    if ($tabPanel.length) {
        $textContainer.each(function () {
            let tabPanelId = $(this).closest(".tab-pane").attr("id");
            let $tabLink = $(`[href="#${tabPanelId}"]`).closest(".nav-item");
            getColor($tabLink);
        });
    }
};

/**
 *  Set height for banner image
 */
const setImgHeight = () => {
    const $imgContainer = $(".hero-banner-background");

    if ($imgContainer.length > 0) {
        $imgContainer.each(function () {
            getHeight($(this));
        });
    }
};

/**
 *  Set banner text container to be clickable
 */
const setTextContainerClickable = () => {
    const $textContainer = $(".hero-banner-text-container");

    $textContainer.on("click", (e) => {
        const $bannerLink = $(e.currentTarget).find(".hero-banner-link");
        window.location.href = $bannerLink.attr("href");
    });
};

export default function () {
    setTextColor();
    setImgHeight();
    setCTAStyle();
    setTextContainerClickable();

    $(window).on("resize", () => {
        setTextColor();
        setImgHeight();
        setCTAStyle();
    });
}
